
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import ChatBox from '@/components/chat/ChatBox';
import { useAuth } from '@/context/AuthProvider';
import QuickEmailTransfer from '@/components/QuickEmailTransfer';
import { useAutoClaimTransfers } from '@/hooks/useAutoClaimTransfers';

const Home = () => {
  const { user, loading } = useAuth();
  const { checkPendingTransfers } = useAutoClaimTransfers();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (!loading && !user) {
      navigate('/signin');
    } else if (user) {
      // Check for any pending transfers when home page loads
      checkPendingTransfers();
    }
  }, [user, loading, navigate, checkPendingTransfers]);
  
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="spinner" />
      </div>
    );
  }
  
  if (!user) return null;

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-lg mx-auto px-4 py-12">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Welcome, {user.email}</h1>
          <p className="text-gray-600">
            Send money securely to anyone using their email
          </p>
        </div>
        
        <div className="grid gap-6">
          <QuickEmailTransfer className="w-full" />
        </div>
      </div>
      
      <ChatBox />
      <Navbar />
    </div>
  );
};

export default Home;
